// Flow types automatically removed

import { Component, Fragment } from 'react';
import DropZone from 'react-dropzone';
import { FormattedMessage } from 'dibs-react-intl';
import classNames from 'classnames';
import ImageDrag from 'dibs-icons/exports/legacy/ImageUploadDrag';
import ImageUploadMultiple from 'dibs-icons/exports/legacy/ImageUploadMultiple';
import Video from 'dibs-icons/exports/legacy/Video';
import PdfIcon from 'dibs-icons/exports/legacy/FilePdf';
import { noop } from './utils';
import { Button } from 'dibs-elements/exports/Button';
import { Link } from 'dibs-elements/exports/Link';
import styles from './styles/BottomBar.scss';

const ErrorMessage = ({ dataTn, children }) => (
    <p data-tn={dataTn} className={styles.error}>
        {children}
    </p>
);

class BottomBar extends Component {
    constructor(props) {
        super(props);
        this.renderDragCopyOrWait = this.renderDragCopyOrWait.bind(this);
        this.openDropZone = this.openDropZone.bind(this);
        this.setDropZoneRef = this.setDropZoneRef.bind(this);
    }

    openDropZone() {
        if (this.dropZoneRef) {
            this.dropZoneRef.open();
        }
    }

    setDropZoneRef(ref) {
        if (ref) {
            this.dropZoneRef = ref;
        }
    }

    renderDragCopyOrWait() {
        const { browseCopy, dragCopy, isPending, pendingCopy, showBrowseCopyFirst, useButton } =
            this.props;

        if (isPending) {
            return <div>{pendingCopy}</div>;
        }

        const renderBrowseAndDragCopy = (dragComponent, browseComponent) => (
            <FormattedMessage
                id="dibs-media-uploader.BottomBar.browseAndDragCopy"
                defaultMessage="{showBrowseCopyFirst, select,
                    true {{browseComponent} {dragComponent}}
                    other {{dragComponent} {browseComponent}}
                }"
                values={{ showBrowseCopyFirst, dragComponent, browseComponent }}
            />
        );

        if (useButton) {
            return (
                <div>
                    {renderBrowseAndDragCopy(
                        <div className={styles.uploadFilesLinkText} data-tn="upload-files-link">
                            {dragCopy}
                        </div>,
                        <Button
                            dataTn="upload-files-button"
                            disabled={isPending}
                            onClick={this.openDropZone}
                            size="medium"
                        >
                            {browseCopy}
                        </Button>
                    )}
                </div>
            );
        }

        return (
            <div className={styles.uploadFilesLinkTextNoButton} data-tn="upload-files-link">
                {renderBrowseAndDragCopy(
                    <span className={styles.dragCopy}>{dragCopy}</span>,
                    <Link onClick={this.openDropZone}>{browseCopy}</Link>
                )}
            </div>
        );
    }

    render() {
        const {
            allowVideo,
            bottomBarType,
            className,
            dropZoneAccept,
            isPending,
            mediaListEmpty,
            requirementsCopy,
            hideUploadBar,
            onDrop,
            horizontalView,
            size,
            errors,
            segmentedView,
            excludePrimaryImage,
            disabled,
        } = this.props;
        const { generalError, uploaderError, standardErrors } = errors || {};
        const isSizeSmall = size === 'small';
        const isSwatchBar = bottomBarType === 'swatch';
        const uploadBarClasses = classNames(
            {
                [styles.noElementsUploadBar]: mediaListEmpty,
                [styles.hasElementsUploadBar]: !mediaListEmpty,
                [styles.horizontalView]: horizontalView,
                [styles.noElementsUploadBarSmall]: mediaListEmpty && isSizeSmall,
                [styles.hasElementsUploadBarSmall]: !mediaListEmpty && isSizeSmall,
                [styles.horizontalDropZone]: isSwatchBar,
                [styles.segmentedDropZone]: segmentedView,
                [styles.belowThumbnails]: segmentedView && !mediaListEmpty,
                [styles.noPrimaryImage]: excludePrimaryImage,
            },
            className
        );
        const photoOrImageIcon = (
            <Fragment>
                {allowVideo && (
                    <div className={styles.video}>
                        <Video />
                    </div>
                )}
                <div
                    className={classNames({
                        [styles.imageDrag]: allowVideo,
                        [styles.imageDragNoVideo]: !allowVideo,
                        [styles.imageDragNoVideoSmall]: !allowVideo && isSizeSmall,
                        [styles.noPrimaryImage]: excludePrimaryImage,
                    })}
                >
                    {excludePrimaryImage ? (
                        <ImageUploadMultiple className={styles.multipleImagesUploadIcon} />
                    ) : (
                        <ImageDrag />
                    )}
                </div>
            </Fragment>
        );
        const pdfIcon = (
            <div className={styles.PDF}>
                <PdfIcon />
            </div>
        );
        const iconWrapper = (
            <div
                className={classNames({
                    [styles.iconWrapper]: true,
                    [styles.iconWrapperSmall]: isSizeSmall,
                })}
            >
                {dropZoneAccept && dropZoneAccept === 'application/pdf'
                    ? pdfIcon
                    : photoOrImageIcon}
            </div>
        );
        const errorsToDisplay = (
            <>
                {uploaderError && mediaListEmpty && (
                    <ErrorMessage dataTn="upload-error">{uploaderError}</ErrorMessage>
                )}
                {generalError && <ErrorMessage dataTn="general-error">{generalError}</ErrorMessage>}
                {standardErrors &&
                    standardErrors.map((error, idx) => (
                        <ErrorMessage dataTn={`error-message-${idx}`} key={`error-message-${idx}`}>
                            {error}
                        </ErrorMessage>
                    ))}
            </>
        );
        return (
            <div
                style={{
                    width: '100%',
                }}
            >
                {hideUploadBar ? null : (
                    <DropZone
                        ref={r => this.setDropZoneRef(r)}
                        accept={dropZoneAccept}
                        noClick
                        onDrop={(!isPending && onDrop) || undefined}
                        disabled={disabled}
                    >
                        {({ getRootProps, getInputProps }) => (
                            <div {...getRootProps()} className={uploadBarClasses}>
                                <input data-tn="bottom-bar-upload-input" {...getInputProps()} />
                                <div
                                    data-tn="image-drop-zone"
                                    className={classNames(styles.wrapper, {
                                        [styles.segmentedWrapper]: segmentedView,
                                    })}
                                >
                                    {iconWrapper}
                                </div>
                                {this.renderDragCopyOrWait()}
                                {requirementsCopy && (
                                    <div
                                        data-tn="upload-files-requirements"
                                        className={styles.requirements}
                                    >
                                        {requirementsCopy}
                                    </div>
                                )}
                                {segmentedView && (
                                    <div className={styles.segmentedViewErrors}>
                                        {errorsToDisplay}
                                    </div>
                                )}
                            </div>
                        )}
                    </DropZone>
                )}
                {!segmentedView && errorsToDisplay}
            </div>
        );
    }
}

BottomBar.defaultProps = {
    dropZoneAccept: 'image/*',
    mediaListEmpty: true,
    onDrop: noop,
    useButton: false,
    horizontalView: false,
    size: 'default',
};
export { BottomBar };
